import {
  isDevelopmentEnv,
  isLocalhost,
  isStagingEnv,
} from 'src/config/constants/sdk';

import { ampli } from '../tracking';

(() => {
  if (typeof window === 'undefined') return;

  ampli.load({
    environment:
      isLocalhost() || isDevelopmentEnv() || isStagingEnv() ? 'stag' : 'prod',
    client: {
      configuration: {
        defaultTracking: false,
      },
    },
  });
})();
